export const COLUMN_WIDTHS = {
  EXPANDED: '67%',
  COLLAPSED: '33%',
};
